import { Schema } from "effect";

export const DraftMessageStatus = Schema.Literal(
  "PENDING",
  "SENDING",
  "SENT",
  "ERROR",
  "DELETED",
);
export type DraftMessageStatus = typeof DraftMessageStatus.Type;
